import { withI18n } from '@squareup/service-i18n/components';
import { i18nLibraryInstance } from '@squareup/service-i18n/library';
import { CashLocalPreview as CashLocalPreviewComponent } from './components/cash-local-preview/cash-local-preview.js';
import { CashLocalPreviewNux as CashLocalPreviewNuxComponent } from './components/cash-local-preview-nux/cash-local-preview-nux.js';

export const CashLocalPreview = withI18n(CashLocalPreviewComponent);
export const CashLocalPreviewNux = withI18n(CashLocalPreviewNuxComponent);
export const i18n = i18nLibraryInstance;
